import React, { Component } from "react";
import { observer } from "mobx-react";
import { Button, Modal } from "semantic-ui-react";
import PropTypes from "prop-types";
import Tour from "~/models/Tour";
import Immersive3dTourExportAdMessage from "~/components/Immersive3dTourExportAdMessage";
import ContentLoader from "~/components/element/ContentLoader";

@observer
class Immersive3dTourExportAdMessageModal extends Component {
  render() {
    const { visible, hideModal, isLoading, tour, tourLoaded } = this.props;

    let modalContentDescription = <ContentLoader />;

    if (!isLoading && tourLoaded && typeof tour.checkoutPageLinks.otherProduct1CheckoutPageLink !== "undefined") {
      modalContentDescription = (
        <Immersive3dTourExportAdMessage
          tourHasReadiedImmersive3dTour={tour.hasReadiedImmersive3dTour}
          otherProduct1CheckoutPageLink={tour.checkoutPageLinks.otherProduct1CheckoutPageLink}
        />
      );
    }

    return (
      <Modal
        open={visible}
        onClose={() => {
          hideModal();
        }}
      >
        <Modal.Header>Immersive 3D Tour Export</Modal.Header>
        <Modal.Content>
          <Modal.Description style={{ minHeight: "9rem" }}>{modalContentDescription}</Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            secondary
            onClick={() => {
              hideModal();
            }}
          >
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

Immersive3dTourExportAdMessageModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  tour: PropTypes.instanceOf(Tour),
  isLoading: PropTypes.bool.isRequired,
  tourLoaded: PropTypes.bool.isRequired,
};

export default Immersive3dTourExportAdMessageModal;
